import { createAction } from "@reduxjs/toolkit";
import { IBranding } from "lobbie";

export const setBranding = createAction<IBranding>("branding/set");
